import { Link } from '@tanstack/react-router';
import React from 'react';

import { useMessages } from '@/hooks/messages';

import { unauthorizedMessageDefinitions } from './messages';

export const Unauthorized: React.FC = () => {
  const messages = useMessages(unauthorizedMessageDefinitions);

  return (
    <div className='flex min-h-screen flex-col items-center justify-center'>
      <h1 className='text-4xl font-bold text-red-600'>{messages.title()}</h1>
      <p className='mt-4 text-gray-700'>{messages.youDoNotHaveAccess()}</p>
      <Link to='/'>{messages.homePageButton()}</Link>
    </div>
  );
};
